import Header from "../Header";
import Footer from "../Footer";
import HorizontalSlider from "../HorizontalSlider";

const Results = () => {
  const tabTitles = ["2025", "2024"];

  return (
    <div>
      <Header />
      <HorizontalSlider items={tabTitles} />
      <Footer />
    </div>
  );
};

export default Results;
